import Question from "models/Question";
import Addition from "models/Addition";
import AdditionChoice from "models/AdditionChoice";

export const SET = "answerQuestion/SET";
export const SET_NEXT_QUESTION = "answerQuestion/SET_NEXT_QUESTION";
export const SET_PREV_QUESTION = "answerQuestion/SET_PREV_QUESTION";
// For Develop
export const SET_CURRENT_QUESTION = "answerQuestion/SET_CURRENT_QUESTION";

export const set = (basicQuestions, additions) => {
  let questions = [];
  // 基本設問
  questions = questions.concat(basicQuestions.map(q => new Question(q)));

  // 追加設問
  questions = questions.concat(
    additions.map(a => {
      const choices = a.choices.map(c => new AdditionChoice(c));
      return new Addition(a).set("choices", choices);
    })
  );

  return {
    type: SET,
    questions,
    basicQuestionCount: basicQuestions.length
  };
};

export const setNextQuestion = () => ({
  type: SET_NEXT_QUESTION
});

export const setPrevQuestion = () => ({
  type: SET_PREV_QUESTION
});

// For Develop
export const setCurrentQuestion = qNo => ({
  type: SET_CURRENT_QUESTION,
  qNo
});

const initialState = {
  questions: [],
  basicQuestionCount: 63,
  currentQuestion: new Question()
};

const answerQuestion = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET: {
      const { questions, basicQuestionCount } = action;
      const currentQuestion = questions[0];

      return { ...state, questions, currentQuestion, basicQuestionCount };
    }

    case SET_NEXT_QUESTION: {
      const nextQuestion = state.questions[state.currentQuestion.qNo];

      return { ...state, currentQuestion: nextQuestion };
    }

    case SET_PREV_QUESTION: {
      const nextQuestion = state.questions[state.currentQuestion.qNo - 2];

      return { ...state, currentQuestion: nextQuestion };
    }

    // For Develop
    case SET_CURRENT_QUESTION: {
      const currentQuestion = state.questions[action.qNo - 1];

      return { ...state, currentQuestion };
    }

    default: {
      return state;
    }
  }
};

export default answerQuestion;



// WEBPACK FOOTER //
// ./src/redux/modules/answer/answerQuestion.js